export default __webpack_public_path__ + "static/media/icon_7.696982fd.png";